<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Přihodit</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content padding>
  <ion-grid>
    <ion-row>
      <ion-col>
        <img [src]="photo.url" alt="">
      </ion-col>
      <ion-col>
        Nejvyšší nabídka je {{photo.currentPrice}} Kč <span *ngIf="photo.currentTopper">od {{photo.currentTopper.name}}</span>.<br>
        Vaše maximální nabídka:
      <form [formGroup]="prihoditForm" (ngSubmit)="prihodit(photo, this.prihoditForm.value.prihoz)">
        <ion-input formControlName="prihoz" style="border: 1px solid black" placeholder="min. {{photo.currentPrice + 50}} Kč"></ion-input>
        <ion-button round large type="submit" [disabled]="!prihoditForm.valid">Přihodit</ion-button>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
